import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {BookOfShadowsParsedGameData} from "../../server/data/BookOfShadowsParsedGameData";
import {BookOfShadowsFreeSpinIntroView} from "./BookOfShadowsFreeSpinIntroView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {BookOfShadowsInactiveRowView} from "../../inactiveRow/BookOfShadowsInactiveRowView";
import {BookOfShadowsGameModuleConfig} from "../../BookOfShadowsGameModuleConfig";
import {SoundManager} from "../../sound/SoundManager";
import {BookOfShadowsSoundConfig} from "../../BookOfShadowsSoundConfig";
import {BookOfShadows} from "../../BookOfShadows";
import {BookOfShadowsGameMode} from "../../gameMode/BookOfShadowsGameMode";
import {TweenLite} from "gsap";

export class BookOfShadowsFreeSpinIntroTransitionController extends GameModeTransitionController {

    private _view: BookOfShadowsFreeSpinIntroView;

    /**
     * @constructs
     * @param fromMode
     * @param toMode
     */
    constructor(fromMode: string, toMode: string) {
        super(fromMode, toMode);

        this._view = new BookOfShadowsFreeSpinIntroView(StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.FREE_SPIN.name), () => this.finish());
    }

    /**
     * @inheritDoc
     * @override => To call the finish once the view is done.
     */
    public start(): void {
        TweenLite.delayedCall(BookOfShadowsGameConfig.instance.ABORT_DELAY, () => this.startAfterDelay());
    }

    /**
     * @inheritDoc
     */
    protected addEventListeners(): void {
        super.addEventListeners();

        EventHandler.addEventListener(this, BookOfShadowsInactiveRowView.ROW_SELECTOR_CLICKED, () => this._view.rowSelectionClickedInFSIntro());
    }

    /**
     * @inheritDoc
     * @param data
     */
    protected onGameDataParsed(data: BookOfShadowsParsedGameData): void {
        super.onGameDataParsed(data);

        this._view.onDataParsed(data);
    }

    /**
     * @inheritDoc
     */
    protected finish(): void {
        if (!BookOfShadowsGameConfig.instance.REDRAW_ON_FS_CLICKED) {
            this._view.cleanUp();

            BookOfShadowsGameModuleConfig.fireParticles.togglePlay(true);
            BookOfShadowsGameModuleConfig.background.toggleFSFrame(true);
            BookOfShadowsGameModuleConfig.inactiveRowController.enteredFS();
            BookOfShadowsGameModuleConfig.reelBackgroundView.toggleFsMode(true);
            BookOfShadowsGameModuleConfig.reelLockController.enteredFS();

            SoundManager.fadeAmbienceLoop(0, 200);
            SoundManager.playAmbientLoop(BookOfShadowsSoundConfig.instance.BONUS_GAME_AMBIANCE, 200);
        }

        super.finish();
    }

    // we don't want to hide/show keypad for this transition.
    protected hideKeypad(): void {
        if (this._fromMode === BookOfShadowsGameMode.FREESPIN_PICK && this._toMode === BookOfShadowsGameMode.FREESPIN_PICK) {
            return;
        }

        super.hideKeypad();
    }

    // we don't want to hide/show keypad for this transition.
    protected showKeypad(): void {
        if (this._fromMode === BookOfShadowsGameMode.FREESPIN_PICK && this._toMode === BookOfShadowsGameMode.FREESPIN_PICK) {
            return;
        }

        super.showKeypad();
    }

    /**
     * @description To start after the abort is done.
     */
    private startAfterDelay(): void {
        BookOfShadowsGameConfig.instance.ABORT_DELAY = 0;

        this.prepareToEnterMode();

        const data: BookOfShadowsParsedGameData = (this._serverData as BookOfShadowsParsedGameData);
        if (data.mode === BookOfShadowsGameMode.FREESPIN_PICK && data.playerChooseRedrawSymbol && (!(data as any).isRestoreState)) {
            BookOfShadowsGameConfig.instance.REDRAW_ON_FS_CLICKED = false;

            return;
        }

        this._view.startAnimation(this._serverData.scatterPositions!);
        SoundManager.playFSStart();

        // #152
        BookOfShadows.autoPlay.cancelAutoPlay();
    }
}